import { client } from "./client/client.gen";
import { ApiErrorException, isApiErrorException, parseApiError } from "./utils/net/apiError";

client.setConfig({ throwOnError: true });

client.interceptors.error.use((error, response) => {
  if (isApiErrorException(error)) {
    return error;
  }

  const status = response?.status ?? 0;
  const apiError = parseApiError(status, error);
  return new ApiErrorException(apiError, error);
});
